import React from 'react';
import { translate } from 'react-i18next';
import clsx from 'clsx';
import { Button, withStyles, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import i18next from 'i18next';
import moment from 'moment';
import { faCalendarAlt, faChevronDown } from '@fortawesome/pro-light-svg-icons';

const styles = theme => ({
    drp: {
        width: 'max-content'
    },
    drpButton: {
        width: '100%',
        height: '100%',
        border: '1px solid #E6EDF5',
        padding: '10px',
        margin: '5px 0px',
        marginTop: -15,
        justifyContent: 'flex-start !important'
    },
    calendarIcon: {
        marginRight: '3px',
        color: '#357ebd',
    },
    containerStylesContainer:{
        marginLeft: 'auto',

    },
    chevronIcon: {
        marginLeft: '7px',
        color: '#357ebd',
    },
    containerStyles: {
        width: '100%',
        // height: '44px'
    },
    labelWrapper: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        marginBottom: '20px'
    },
    label: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },
    dateContainer:{
        width: '100%'
    }
});

// const containerStyles = {
//     width: '100%',
//     height: '44px'
// }

class ReactDateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLang: i18next.language,
        };
    }

    componentDidUpdate = () => {
        if (i18next.language !== this.state.currentLang) {
            this.setState({
                currentLang: i18next.language,
            });
        };
    };

    render() {
        const { t, onApply = () => { }, classes, date, customContainerStyle, customClass, label, disabled = false,...other } = this.props;

        let customClassAUX = typeof customClass !== undefined ? customClass : '';
        let containerStylesAUX = typeof customContainerStyle !== undefined ? customContainerStyle : '';

        let locale = {
            search: 'Filtrer',
            daysOfWeek: moment.weekdaysShort(),
            monthNames: moment.months(),
        };
        let button = (
            <Button disabled={disabled} className={clsx(classes.drpButton, customClassAUX)}>
                <div className="pull-left">
                    <FontAwesomeIcon className={classes.calendarIcon} icon={faCalendarAlt} />
                    <span>
                        {date}
                    </span>
                </div>
                <div className={clsx(classes.containerStylesContainer, "pull-right")}>
                    <FontAwesomeIcon className={classes.chevronIcon} icon={faChevronDown} />
                </div>
            </Button>
        )

        return (
            <React.Fragment>
            <div className={classes.dateContainer}>
                {label ?
                    <div className={clsx(classes.labelWrapper)}>
                        <Typography className={clsx(classes.label)}>{label}</Typography>
                    </div>
                    : ''}
                {disabled ? button :
                    <DateRangePicker
                        applyClass={'singleDatePicker'}
                        timePickerIncrement={5}
                        singleDatePicker
                        onApply={onApply}
                        className={classes.drp}
                        locale={locale}
                        onShow={()=>{document.getElementsByClassName('daterangepicker single')[0].getElementsByClassName("ranges")[0].style.display = "none";}}
                        onHideCalendar={()=>{document.getElementsByClassName('daterangepicker single')[0].getElementsByClassName("ranges")[0].style.display = "inherit";}}
                        alwaysShowCalendars={false}
                        containerClass={clsx(classes.containerStyles, containerStylesAUX)}
                        {...other}
                    >
                        {button}
                    </DateRangePicker>
                }
                </div>
            </React.Fragment>
        );
    }
}

export default translate('common')(withStyles(styles)(ReactDateRangePicker));